
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("h4oCC", function(module, exports) {
/**
 * @generated SignedSource<<e6d20f14365dfcef5db10c797898d3cf>>
 * @relayHash fe506bd9046797cde11ab0f7fcc9d885
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 854f59c2498e8df1c5c0ea0d63c7c4d8d62ad62311c64a732f4a327d479681be
const $53f7ad90e8632c3f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "SpaceSidebarLinks",
            "kind": "LinkedField",
            "name": "spaceSidebarLinks",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "concreteType": "SpaceSidebarLink",
                    "kind": "LinkedField",
                    "name": "quick",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "position"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "styleClass"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useShortcutsSpaceNavigationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useShortcutsSpaceNavigationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fe506bd9046797cde11ab0f7fcc9d885",
            "id": "854f59c2498e8df1c5c0ea0d63c7c4d8d62ad62311c64a732f4a327d479681be",
            "metadata": {},
            "name": "useShortcutsSpaceNavigationQuery",
            "operationKind": "query",
            "text": "query useShortcutsSpaceNavigationQuery($spaceKey:String){spaceSidebarLinks(spaceKey:$spaceKey){__typename,quick{id,url,position,title,styleClass}}}"
        }
    };
}();
$53f7ad90e8632c3f$var$node.hash = "52dba71769af710a3e1e472bed635436";
var $53f7ad90e8632c3f$export$2e2bcd8739ae039 = $53f7ad90e8632c3f$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $8hDyr = parcelRequire("8hDyr");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $c0rhi = parcelRequire("c0rhi");


var $ep3mz = parcelRequire("ep3mz");


var $aBfpe = parcelRequire("aBfpe");


var $9o40q = parcelRequire("9o40q");

const $8eef8a4d96281ace$export$432c692df9866bf7 = ()=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: '/wiki/rest/ia/1.0/link/batch',
        method: 'POST',
        body: (variables)=>JSON.stringify(variables),
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: ({ quickLinks: quickLinks })=>{
            const links = quickLinks.map(({ id: id, position: position, styleClass: styleClass, title: title, url: url })=>({
                    id: String(id),
                    position: String(position),
                    styleClass: styleClass,
                    title: title,
                    url: url
                }));
            return {
                experimentalUpdateShortcutLinks: {
                    quickLinks: links,
                    __typename: 'ExperimentalQuickLinks'
                }
            };
        }
    });
};


const $63d5f9bbea23d6c9$var$i18n = (0, $kSwu1.defineMessages)({
    reorderShortcutSuccessFlagTitle: {
        id: "space-shortcuts.space-space-shortcuts.reorder-success-flag.title",
        defaultMessage: "The shortcut was reordered"
    },
    reorderShortcutErrorFlagTitle: {
        id: "space-shortcuts.space-space-shortcuts.reorder-error-flag.title",
        defaultMessage: "The shortcut could not be reordered"
    },
    reorderShortcutErrorFlagDescription: {
        id: "space-shortcuts.space-space-shortcuts.reorder-error-flag.description",
        defaultMessage: "There was an error moving the shortcut. Refresh and try again." //TODO: if possible, return reason for failure, to follow page tree errors
    },
    removeShortcutSuccessFlagTitle: {
        id: "space-shortcuts.space-space-shortcuts.remove-success-flag.title",
        defaultMessage: "The shortcut was removed"
    },
    removeShortcutErrorFlagTitle: {
        id: "space-shortcuts.space-space-shortcuts.remove-error-flag.title",
        defaultMessage: "The shortcut could not be removed"
    },
    removeShortcutErrorFlagDescription: {
        id: "space-shortcuts.space-space-shortcuts.remove-error-flag.description",
        defaultMessage: "There was an error removing the shortcut. Refresh and try again." //TODO: if possible, return reason for failure, to follow page tree errors
    },
    addShortcutSuccessFlagTitle: {
        id: "space-shortcuts.space-space-shortcuts.add-success-flag.title",
        defaultMessage: "New shortcut added"
    },
    addShortcutErrorFlagTitle: {
        id: "space-shortcuts.space-space-shortcuts.add-error-flag.title",
        defaultMessage: "The shortcut could not be added"
    },
    addShortcutErrorFlagDescription: {
        id: "space-shortcuts.space-space-shortcuts.add-error-flag.description",
        defaultMessage: "There was an error creating the shortcut. Refresh and try again." //TODO: if possible, return reason for failure, to follow page tree errors
    },
    editShortcutSuccessFlagTitle: {
        id: "space-shortcuts.space-space-shortcuts.edit-success-flag.title",
        defaultMessage: "The shortcut was edited"
    },
    editShortcutErrorFlagTitle: {
        id: "space-shortcuts.space-space-shortcuts.edit-error-flag.title",
        defaultMessage: "The shortcut could not be edited"
    },
    editShortcutErrorFlagDescription: {
        id: "space-shortcuts.space-space-shortcuts.edit-error-flag.description",
        defaultMessage: "There was an error updating the shortcut. Refresh and try again."
    },
    flagUndoAction: {
        id: "space-shortcuts.space-space-shortcuts.undo-action",
        defaultMessage: "Undo"
    }
});
const $63d5f9bbea23d6c9$export$2ed3897d6a288438 = (0, $53f7ad90e8632c3f$export$2e2bcd8739ae039);
const $63d5f9bbea23d6c9$var$useUpdateShortcuts = (flags, ref)=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [updateShortcutsMutation] = (0, $8eef8a4d96281ace$export$432c692df9866bf7)();
    return (0, $cozmU.useCallback)((newLinks, changedItem, successCopyTitle, errorCopyTitle, errorCopyDesc, showFlag = true, oldItem)=>{
        const mutationPayload = newLinks.map((link)=>{
            if (link.hasOwnProperty('id') && link.id && !oldItem) return {
                id: link.id
            };
            return {
                id: link.id,
                title: link.title,
                url: link.url,
                resourceType: link.resourceType,
                resourceId: link.resourceId
            };
        });
        const optimisticUpdate = newLinks.map((link)=>{
            return {
                // must remove id to prevent "Could not find link ID" errors from server
                id: link.id && link.id.startsWith('cached-') ? null : link.id,
                title: link.title,
                url: link.url,
                resourceType: link.resourceType,
                resourceId: link.resourceId
            };
        });
        // Store the original state before optimistic update for rollback
        let originalState;
        try {
            originalState = (0, $l1uFv.readQueryInterop)({
                query: $63d5f9bbea23d6c9$export$2ed3897d6a288438,
                variables: {
                    spaceKey: spaceKey
                },
                __callerPackage__: "space-shortcuts"
            });
        } catch  {
        // Errors can be safely ignored as if there is no cache entry, there is no work to be done.
        }
        return updateShortcutsMutation({
            variables: {
                spaceKey: spaceKey || '',
                quickLinks: mutationPayload
            },
            optimisticResponse: {
                experimentalUpdateShortcutLinks: {
                    quickLinks: optimisticUpdate,
                    __typename: 'ExperimentalQuickLinks'
                }
            },
            update: (_, result)=>{
                const { data: data } = result;
                // Handle rollback: when data is undefined, restore original state
                if (data === undefined) {
                    if (originalState) (0, $fEmGS.writeQueryInterop)({
                        query: $63d5f9bbea23d6c9$export$2ed3897d6a288438,
                        data: originalState,
                        variables: {
                            spaceKey: spaceKey
                        },
                        __callerPackage__: "space-shortcuts"
                    });
                    return;
                }
                newLinks = newLinks.map((link)=>// provides an id to be used as the key for the Draggable component in ShortcutsDragContainer
                    // otherwise it will use index and re-render unnecessarily
                    link.id === null ? {
                        ...link,
                        id: `cached-${changedItem.id}`
                    } : link);
                const massagedData = data?.experimentalUpdateShortcutLinks?.quickLinks ? data?.experimentalUpdateShortcutLinks?.quickLinks.map((link)=>{
                    return {
                        ...link,
                        __typename: 'SpaceSidebarLink'
                    };
                }) : newLinks;
                (0, $fEmGS.writeQueryInterop)({
                    query: $63d5f9bbea23d6c9$export$2ed3897d6a288438,
                    data: {
                        spaceSidebarLinks: {
                            quick: massagedData,
                            __typename: 'SpaceSidebarLinks'
                        }
                    },
                    variables: {
                        spaceKey: spaceKey
                    },
                    __callerPackage__: "space-shortcuts"
                });
            }
        }).then(()=>{
            // showFlag parameter is to prevent the flag from showing again when pressing "undo"
            if (showFlag) {
                changedItem = ref?.current?.peek()?.lastDeletedItem || changedItem;
                const id = 'shortcutsFlag';
                flags.showSuccessFlag({
                    id: id,
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), successCopyTitle),
                    actions: ref && [
                        {
                            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $63d5f9bbea23d6c9$var$i18n.flagUndoAction),
                            onClick: ()=>{
                                const reverseMovement = ref.current.pop();
                                if (reverseMovement) {
                                    const { undo: undoFn } = reverseMovement;
                                    if (undoFn) undoFn();
                                }
                                flags.hideFlag(id);
                            }
                        }
                    ]
                });
                if (ref) {
                    const historyEntry = ref.current.peek();
                    if (historyEntry) historyEntry.flagId = id;
                }
            }
        }).catch(()=>{
            flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), errorCopyTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...errorCopyDesc,
                    values: {
                        linkTitle: changedItem.title || changedItem.url
                    }
                })
            });
        });
    }, [
        updateShortcutsMutation,
        spaceKey,
        flags,
        ref
    ]);
};
const $63d5f9bbea23d6c9$var$updateShortcutsWithNewItem = (newItem, rawLinks, updateShortcuts)=>{
    rawLinks.reverse();
    const reorderedLinks = rawLinks.map((link)=>({
            ...link,
            position: link.position++
        }));
    const newLinks = [
        ...reorderedLinks,
        {
            ...newItem,
            id: null,
            position: 0,
            styleClass: 'external_link',
            __typename: 'SpaceSidebarLink'
        }
    ];
    newLinks.reverse();
    updateShortcuts(newLinks, newItem, $63d5f9bbea23d6c9$var$i18n.addShortcutSuccessFlagTitle, $63d5f9bbea23d6c9$var$i18n.addShortcutErrorFlagTitle, $63d5f9bbea23d6c9$var$i18n.addShortcutErrorFlagDescription);
};
const $63d5f9bbea23d6c9$export$b8c12283ebc8f305 = (rawLinks, flags, ref)=>{
    const updateShortcuts = $63d5f9bbea23d6c9$var$useUpdateShortcuts(flags, ref);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { linkDeleted: linkDeleted } = (0, $8hDyr.useSmartLinkLifecycleAnalytics)();
    const addShortcut = (0, $cozmU.useCallback)((newItem, source = 'spaceShortcutNavigation')=>{
        $63d5f9bbea23d6c9$var$updateShortcutsWithNewItem(newItem, rawLinks, updateShortcuts);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'add',
                actionSubject: 'spaceShortcuts',
                source: source
            }
        }).fire();
    }, [
        rawLinks,
        updateShortcuts,
        createAnalyticsEvent
    ]);
    const undoAddShortcut = (0, $cozmU.useCallback)((newItem, source = 'spaceShortcutNavigation')=>{
        const newLinks = rawLinks.filter((item)=>item.id !== newItem.id);
        newLinks.reverse();
        updateShortcuts(newLinks, newItem, $63d5f9bbea23d6c9$var$i18n.removeShortcutSuccessFlagTitle, $63d5f9bbea23d6c9$var$i18n.removeShortcutErrorFlagTitle, $63d5f9bbea23d6c9$var$i18n.removeShortcutErrorFlagDescription, false);
        const analyticsEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'undo',
                actionSubject: 'add',
                actionSubjectId: 'spaceShortcuts',
                source: source
            }
        });
        analyticsEvent.fire();
        if (newItem.url) linkDeleted({
            url: newItem.url
        }, analyticsEvent);
    }, [
        rawLinks,
        updateShortcuts,
        createAnalyticsEvent,
        linkDeleted
    ]);
    return {
        addShortcut: addShortcut,
        undoAddShortcut: undoAddShortcut
    };
};
const $63d5f9bbea23d6c9$export$e02d6de77d7e65a = (flags)=>{
    const updateShortcuts = $63d5f9bbea23d6c9$var$useUpdateShortcuts(flags);
    const appendShortcut = (spaceKey, contentId)=>{
        const newItem = {
            url: `${window.location.origin}/wiki/spaces/${spaceKey}/pages/${contentId}`
        };
        (0, $c0rhi.queryInterop)({
            query: $63d5f9bbea23d6c9$export$2ed3897d6a288438,
            variables: {
                spaceKey: spaceKey
            },
            __callerPackage__: "space-shortcuts"
        }).then(({ data: data })=>{
            $63d5f9bbea23d6c9$var$updateShortcutsWithNewItem(newItem, data?.spaceSidebarLinks?.quick || [], updateShortcuts);
        }).catch(()=>{
            flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $63d5f9bbea23d6c9$var$i18n.addShortcutErrorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $63d5f9bbea23d6c9$var$i18n.addShortcutErrorFlagDescription)
            });
        });
    };
    return {
        appendShortcut: appendShortcut
    };
};
const $63d5f9bbea23d6c9$export$a82c8cdf5735c59d = (rawLinks, flags, spaceId)=>{
    const updateShortcuts = $63d5f9bbea23d6c9$var$useUpdateShortcuts(flags);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return (0, $cozmU.useCallback)((editItem)=>{
        // create new quick link list with edited item
        const newLinks = Array.from(rawLinks).reverse();
        const editLinkPosition = newLinks.findIndex((item)=>item.id === editItem.id);
        const oldItem = newLinks[editLinkPosition];
        newLinks.splice(editLinkPosition, 1, editItem);
        // reverse the link list in preparation of storing the data with the mutation in reverse order
        newLinks.reverse();
        updateShortcuts(newLinks, editItem, $63d5f9bbea23d6c9$var$i18n.editShortcutSuccessFlagTitle, $63d5f9bbea23d6c9$var$i18n.editShortcutErrorFlagTitle, $63d5f9bbea23d6c9$var$i18n.editShortcutErrorFlagDescription, true, oldItem);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'updated',
                actionSubject: 'spaceShortcuts',
                source: 'space-shortcut-quick-action',
                containerId: spaceId,
                containerType: 'space'
            }
        }).fire();
    }, [
        rawLinks,
        updateShortcuts,
        createAnalyticsEvent,
        spaceId
    ]);
};
const $63d5f9bbea23d6c9$export$c18103535543c135 = (rawLinks, flags, ref)=>{
    const updateShortcuts = $63d5f9bbea23d6c9$var$useUpdateShortcuts(flags, ref);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { linkCreated: linkCreated, linkDeleted: linkDeleted } = (0, $8hDyr.useSmartLinkLifecycleAnalytics)();
    const deleteShortcut = (0, $cozmU.useCallback)((removedItem)=>{
        const newLinks = rawLinks.filter((item)=>item.id !== removedItem.id);
        updateShortcuts(newLinks, removedItem, $63d5f9bbea23d6c9$var$i18n.removeShortcutSuccessFlagTitle, $63d5f9bbea23d6c9$var$i18n.removeShortcutErrorFlagTitle, $63d5f9bbea23d6c9$var$i18n.removeShortcutErrorFlagDescription);
        const analyticsEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'deleted',
                actionSubject: 'spaceShortcuts',
                source: 'space-shortcut-quick-action'
            }
        });
        analyticsEvent.fire();
        if (removedItem.url) linkDeleted({
            url: removedItem.url
        }, analyticsEvent);
    }, [
        rawLinks,
        updateShortcuts,
        createAnalyticsEvent,
        linkDeleted
    ]);
    const undoDeleteShortcut = (0, $cozmU.useCallback)((removedItem)=>{
        // must remove id to prevent "Could not find link ID" errors from server
        const newLinks = rawLinks.map((item)=>item.id === removedItem.id ? {
                ...item,
                id: null
            } : item);
        updateShortcuts(newLinks, removedItem, $63d5f9bbea23d6c9$var$i18n.removeShortcutSuccessFlagTitle, $63d5f9bbea23d6c9$var$i18n.removeShortcutErrorFlagTitle, $63d5f9bbea23d6c9$var$i18n.removeShortcutErrorFlagDescription, false);
        const analyticsEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'undo',
                actionSubject: 'delete',
                actionSubjectId: 'spaceShortcuts',
                source: 'space-shortcut-quick-action'
            }
        });
        analyticsEvent.fire();
        if (removedItem.url) linkCreated({
            url: removedItem.url
        }, analyticsEvent);
    }, [
        rawLinks,
        updateShortcuts,
        createAnalyticsEvent,
        linkCreated
    ]);
    return {
        deleteShortcut: deleteShortcut,
        undoDeleteShortcut: undoDeleteShortcut
    };
};
const $63d5f9bbea23d6c9$export$c440e2bcdec45821 = (rawLinks, flags, ref)=>{
    const updateShortcuts = $63d5f9bbea23d6c9$var$useUpdateShortcuts(flags, ref);
    const moveShortcut = (0, $cozmU.useCallback)((source, destination)=>{
        // create new quick link list with rearranged items
        const newLinks = Array.from(rawLinks).reverse();
        const [removedItem] = newLinks.splice(source.index, 1);
        newLinks.splice(destination.index, 0, removedItem);
        // reverse the link list in preparation of storing the data with the mutation in reverse order
        newLinks.reverse();
        updateShortcuts(newLinks, removedItem, $63d5f9bbea23d6c9$var$i18n.reorderShortcutSuccessFlagTitle, $63d5f9bbea23d6c9$var$i18n.reorderShortcutErrorFlagTitle, $63d5f9bbea23d6c9$var$i18n.reorderShortcutErrorFlagDescription);
    }, [
        rawLinks,
        updateShortcuts
    ]);
    const undoMoveShortcut = (0, $cozmU.useCallback)((source)=>{
        const newLinks = Array.from(rawLinks).reverse();
        const [removedItem] = newLinks.slice(source.index, 1);
        newLinks.reverse();
        updateShortcuts(newLinks, removedItem, $63d5f9bbea23d6c9$var$i18n.reorderShortcutSuccessFlagTitle, $63d5f9bbea23d6c9$var$i18n.reorderShortcutErrorFlagTitle, $63d5f9bbea23d6c9$var$i18n.reorderShortcutErrorFlagDescription, false);
    }, [
        rawLinks,
        updateShortcuts
    ]);
    return {
        moveShortcut: moveShortcut,
        undoMoveShortcut: undoMoveShortcut
    };
};
module.exports["useAddShortcut"] = $63d5f9bbea23d6c9$export$b8c12283ebc8f305;
module.exports["useAppendShortcut"] = $63d5f9bbea23d6c9$export$e02d6de77d7e65a;
module.exports["useEditShortcut"] = $63d5f9bbea23d6c9$export$a82c8cdf5735c59d;
module.exports["useDeleteShortcut"] = $63d5f9bbea23d6c9$export$c18103535543c135;
module.exports["useMoveShortcut"] = $63d5f9bbea23d6c9$export$c440e2bcdec45821;

});


//# sourceMappingURL=QuickActionsContent.f1e02e6a.js.map
